import { RootState } from '@App/redux/store'

export const selectCalendarEvents = (state: RootState) => state.calendarEvents

export const selectEventById = (state: RootState, id: number) => state.calendarEvents.find((e) => e.id === id)
